// extracted by mini-css-extract-plugin
export default {"button":"styles_button__qitW8","failed":"styles_failed__yTxlP","passed":"styles_passed__RivHK"};